import React from 'react'
import classnames from 'classnames'
import './Driver.css'

const Driver = ({ name, description }) => {
  const classes = classnames({
    Driver: true,
    small: true,
    bold: true,
    caps: true,
    'ls-small': true,
    hasDescription: description && description.length > 0,
  })

  return <div className={classes}>{name}</div>
}

export default Driver



// WEBPACK FOOTER //
// ./src/components/Driver.js